// contexts/SubscriptionContext.js
// Provides subscription state (subStatus, planFeatures, firmProfile, userProfile)
// to the component tree without prop drilling.
//
// Usage:
//   import { useSubscription } from '../contexts/SubscriptionContext';
//   const { subStatus, planFeatures, firmProfile } = useSubscription();
//
// The Provider is mounted in FirmAssist (App.js). Once feature components are
// extracted into separate files, replace their firmProfile/subStatus/planFeatures
// props with this hook.

import { createContext, useContext } from 'react';

export const SubscriptionContext = createContext(null);

/**
 * @returns {{
 *   subStatus: { active: boolean, plan: string|null, daysLeft: number, isTrialing: boolean, isExpired: boolean, isSuperAdmin?: boolean },
 *   planFeatures: object,
 *   firmProfile: object|null,
 *   userProfile: object|null,
 *   setFirmProfile: (profile: object) => void,
 * }}
 */
export const useSubscription = () => {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) throw new Error('useSubscription must be used inside SubscriptionContext.Provider');
  return ctx;
};
